import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { useStore } from '../contexts/StoreContext';
import { Lead } from '../types/lead';
import { buildWhatsAppUrl } from '../utils/validation';
import { leadWhatsAppText } from '../utils/leadMessage';

/** Después de registrar la consulta, el cliente la envía con un toque al WhatsApp comercial. */
export function LeadWhatsAppHandoff({
  lead
}: {
  lead: Lead;
}) {
  const {
    settings
  } = useStore();
  if (!settings.whatsapp) return null;
  return <div className="mt-4" data-id="element-986" data-mp="29ipdrdi7l1f1">
      <a href={buildWhatsAppUrl(settings.whatsapp, leadWhatsAppText(lead))} target="_blank" rel="noopener noreferrer" className="btn btn-wa h-12 w-full" data-id="element-987" data-mp="29he9zdorjtnx">
        <MessageCircleIcon className="h-4 w-4" aria-hidden data-id="element-988" data-mp="2j91u0tizq8fd" />
        Enviar mi consulta por WhatsApp
      </a>
      <p className="mt-2 text-center text-[11px] text-mist" data-id="element-989" data-mp="2x81gpvmy0d8w">Así te respondemos más rápido. El mensaje ya va armado con tu consulta.</p>
    </div>;
}